import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    PROFILE: {
        url: "profile",
        method: "get",
    },

    VALIDATE_PASSWORD: {
        url: "users/validate",
        method: "post",
    },

    GET_QR: (iAdminId) => ({
        url: `2fa/generateQRCode?iAdminId=${iAdminId}`,
        method: "get",
    }),

    EVENTS: {
        url: "events",
        method: "get",
    },

    ENABLE_2FA: {
        url: "2fa/enable",
        method: "post",
    },

    DISABLE_2FA: {
        url: "2fa/disable",
        method: "post",
    },

    VERIFY_DISABLE_EMAIL: {
        url: "2fa/verify-disable-email-code",
        method: "post",
    },

    SEND_EMAIL_LINK: {
        url: "send-email-code",
        method: "post",
    },

    CHANGE_PASSWORD: {
        url: "users/change-password",
        method: "post",
    },

    SAVE_PROFILE: {
        url: "save-or-update-details",
        method: "post",
    },

    UPDATE_COMMUNICATION: {
        url: "profile-communicatie",
        method: "post",
    },

    UPDATE_USERNAME: (id) => ({
        url: `users/${id}`,
        method: "patch",
    }),

    UPDATE_PROFILE_PHOTO: {
        url: "gebruiker/uploadImage",
        method: "post",
    },

    VALIDATE_ADDRESS: {
        url: "address/validate",
        method: "post",
    },

    SAVE_ADDRESS: {
        url: "address/save",
        method: "post",
    },

    DELETE_PROFILE_IMAGE: {
        url: "/profile/image",
        method: "delete",
    },
};

export const useProfile = () =>
    useApiFetcherSWR(API_ENDPOINT.PROFILE);

export const useValidatePassword = () =>
    useApiFetcherSWR(API_ENDPOINT.VALIDATE_PASSWORD);

export const useGetQR = (iAdminId) =>
    useApiFetcherSWR(
        iAdminId
            ? API_ENDPOINT.GET_QR(iAdminId)
            : { url: null, method: "get" }
    );

export const useEnable2FA = () =>
    useApiFetcherSWR(API_ENDPOINT.ENABLE_2FA);

export const useEvents = () =>
    useApiFetcherSWR(API_ENDPOINT.EVENTS);

export const useDisable2FA = () =>
    useApiFetcherSWR(API_ENDPOINT.DISABLE_2FA);

export const useVerifyDisableEmail = () =>
    useApiFetcherSWR(API_ENDPOINT.VERIFY_DISABLE_EMAIL);

export const useSendEmailLink = () =>
    useApiFetcherSWR(API_ENDPOINT.SEND_EMAIL_LINK);

export const useChangePassword = () =>
    useApiFetcherSWR(API_ENDPOINT.CHANGE_PASSWORD);

export const useSaveProfile = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_PROFILE);

export const useUpdateCommunication = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_COMMUNICATION);

export const useUpdateUsername = (id) =>
    useApiFetcherSWR(
        id
            ? API_ENDPOINT.UPDATE_USERNAME(id)
            : { url: null, method: "post" }
    );

export const useUpdateProfilePhoto = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_PROFILE_PHOTO);

export const useValidateAddress = () =>
    useApiFetcherSWR(API_ENDPOINT.VALIDATE_ADDRESS);

export const useSaveAddress = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_ADDRESS);

export const useDeleteProfileImage = () =>
    useApiFetcherSWR(API_ENDPOINT.DELETE_PROFILE_IMAGE);